import React from 'react';
import PropTypes from 'prop-types';

function OneStopShopOne(props) {
  const { height, width } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-22 0 140 84" width={width} height={height}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#fff"
            d="M34.59,0h0a8,8,0,0,1,4,1.07L59.31,13l2,1.15,2-1.16L84,1.07A8,8,0,0,1,96,8V64.76a8,8,0,0,1-4,6.93L65.31,87.1a8,8,0,0,1-8,0L36.68,75.16l-2-1.16-2,1.16L12,87.1A8,8,0,0,1,0,80.17V23.4a8,8,0,0,1,4-6.92L30.58,1.08a8,8,0,0,1,4-1.08"
          />
          <path
            fill="none"
            stroke="#333"
            strokeMiterlimit={10}
            strokeWidth="2.33px"
            d="M61.31,79.78,88,64.37V7.61L61.31,23,34.59,7.61,8,23V79.78L34.68,64.37Z"
          />
          <polygon
            stroke="#52b7b0"
            fill="#52b7b0"
            opacity={0.4}
            points="84.8 62.43 62.49 74.54 62.49 26.06 84.8 13.79 84.8 62.43"
          />
          <polygon fill="#6a445a" points="33.37 61.68 11.06 73.78 11.06 25.3 33.37 13.04 33.37 61.68" />
          <ellipse fill="#333" cx="62.82" cy="46.68" rx="2.95" ry="2.98" />
          <polygon fill="#6a445a" points="65.44 39.76 69.46 43.48 70.05 48.93 79 38.69 65.44 39.76" />
          <polygon fill="#6a445a" points="60.49 53.33 56.47 49.61 55.88 44.16 46.94 54.4 60.49 53.33" />
        </g>
      </g>
    </svg>
  );
}

OneStopShopOne.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

OneStopShopOne.defaultProps = {
  height: 84,
  width: 140
};

export default OneStopShopOne;
